//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/mixins/utils'
import { projectQuery } from '~/graphql/queries/project'
import Modules from '@/components/Modules'
import Media from '@/components/Media'
import Footer from '@/components/Footer'
import Animation from '@/components/Animation'
import RelatedProject from '@/components/project/RelatedProject'
// import ModuleColors from '@/components/modules/ModuleColors'
export default {
  components: {
    Modules,
    Media,
    Footer,
    Animation,
    RelatedProject,
    // ModuleColors,
  },
  mixins: [utils],

  async asyncData({ app, route, payload }) {
    const query = {
      query: projectQuery,
      variables: {
        slug: route.params.uid,
      },
      prefetch: true,
    }

    // For previews
    if (route.query.preview) {
      query.errorPolicy = 'all'
      query.fetchPolicy = 'no-cache'
    }

    if (payload && payload.page) {
      const newPage = payload.page
      newPage.id = payload.page.id
      return { project: newPage }
    } else {
      const project = await app.apolloProvider.defaultClient.query(query)
      return { project: project.data.projects.data[0] }
    }
  },
  head() {
    return {
      title: this.project.attributes.title + ' — Thank You Studios',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.project.attributes.title + ' — Thank You Studios',
        },
        {
          hid: 'description',
          name: 'description',
          content: this.project.attributes.headline,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.project.attributes.headline,
        },
      ],
    }
  },

  computed: {
    category() {
      switch (this.getType(this.project.attributes.type)) {
        case 'pictures':
          return 'Genre'
        default:
          return 'Services'
      }
    },
    backgroundColor() {
      return this.$store.getters.getBackground
    },
    prevProject() {
      const current = this.projects.findIndex(
        (project) => project.id === this.project.id
      )
      return (
        this.projects[current - 1] || this.projects[this.projects.length - 1]
      )
    },
    nextProject() {
      const current = this.projects.findIndex(
        (project) => project.id === this.project.id
      )
      return this.projects[current + 1] || this.projects[0]
    },
    projects() {
      let projects = this.$store.state.projects
      projects = projects.filter(
        (project) =>
          this.getType(project.attributes.type) ===
          this.getType(this.project.attributes.type)
      )
      if (this.project.attributes.status.data) {
        projects = projects.filter((project) => {
          const found = project.attributes.status.data
            ? project.attributes.status.data.attributes.title ===
              this.project.attributes.status.data.attributes.title
            : false
          return found
        })
      }

      return projects
    },
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0)
      this.$colorMode.preference = 'dark'
    }, 10)
  },
}
